import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { securityMcpOAuthApprovePostAsyncSlice } from './approve';
import { securityMcpOAuthDenyPostAsyncSlice } from './deny';

export const securityMcpOAuthApproveReducers = combineReducers({
	approve: securityMcpOAuthApprovePostAsyncSlice.asyncReducers,
	deny: securityMcpOAuthDenyPostAsyncSlice.asyncReducers
});

export const securityMcpOAuthApproveWatchers = combineAllWatchers([
	securityMcpOAuthApprovePostAsyncSlice.asyncWatchers,
	securityMcpOAuthDenyPostAsyncSlice.asyncWatchers
]);
